export interface ISchoolTerm {
  term: string;

  status: SchoolTermEnum;
}
export enum SchoolTermEnum {
  NEXT = 'NEXT',
  CURRENT = 'CURRENT',
  ARCHIVED = 'ARCHIVED',
}
